module.exports = __webpack_public_path__ + "static/img/logo.d4a4853.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.svg
// module id = zxL1
// module chunks = 56